import React from 'react';
import {List} from 'semantic-ui-react'

class AppSidebarNavReporting extends React.Component {
  render() {
    return (
      <List link>
        <List.Item>
          <List.Content as="a">
            Account Setup
          </List.Content>
        </List.Item>
        <List.Item active>
          <List.Content as="a">
            Alpha
          </List.Content>
          <List link>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
          </List>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Beta
          </List.Content>
          <List link>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
          </List>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Verifications
          </List.Content>
        </List.Item>
        <List.Item>
          <List.Content as="a">
            Gamma
          </List.Content>
          <List link>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
            <List.Item as="a">Sub</List.Item>
          </List>
        </List.Item>
      </List>
    );
  }
}

AppSidebarNavReporting.displayName = 'AppSidebarNavReporting';
AppSidebarNavReporting.propTypes = {};
AppSidebarNavReporting.defaultProps = {};
export { AppSidebarNavReporting };



// WEBPACK FOOTER //
// ./src/components/app/sidebar/NavReporting.js